import React, { createContext, type Dispatch, type ReactNode, type SetStateAction, useContext, useState } from 'react';

import { Web3AuthSteps } from '../Web3Auth.types';

interface Web3AuthContextType {
    currentStep: Web3AuthSteps;
    authEmail: string;
    setCurrentStep: Dispatch<SetStateAction<Web3AuthSteps>>;
    setAuthEmail: Dispatch<SetStateAction<string>>;
}

interface Web3AuthContextProviderProps {
    children: ReactNode;
    step?: Web3AuthSteps;
}

const Web3AuthContext = createContext<Web3AuthContextType>({
    currentStep: Web3AuthSteps.Entry,
    authEmail: '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCurrentStep: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setAuthEmail: () => {},
});

export const useWeb3AuthContext = () => useContext(Web3AuthContext);

export function Web3AuthContextProvider({ children, step }: Web3AuthContextProviderProps) {
    const [currentStep, setCurrentStep] = useState<Web3AuthSteps>(step ?? Web3AuthSteps.Entry);
    const [authEmail, setAuthEmail] = useState('');

    return (
        <Web3AuthContext.Provider value={{ currentStep, setCurrentStep, authEmail, setAuthEmail }}>
            {children}
        </Web3AuthContext.Provider>
    );
}
